import toastr from "toastr";
import Http from '@shared/http'

export const submitBillingDetails = async (state, billing_details) => {
  const {
    paths: { saveBillingDetailsPath }
  } = state

  toastr.options.positionClass = 'toast-footer-small'

  const response = await Http.request(saveBillingDetailsPath, 'POST', JSON.stringify({ billing_details }))
  
  if (!response?.ok) {
    toastr.warning(
      'Something went wrong saving your Billing details. Please try again.'
    )
    return false
  }
  
  toastr.success(
    'Billing details updated successfully.'
  )
  return response.json()
}

export const initiateCheckout = async (state) => {
  const {
    paths: { initiateCheckoutPath }
  } = state

  toastr.options.positionClass = 'toast-footer-small'

  const response = await Http.request(initiateCheckoutPath)
  
  if (!response?.ok) {
    toastr.warning(
      'Something went wrong initiating checkout. Please try again.'
    )
    return false
  }
  
  return response.json()
}

export const registerCard = async (state, card_details) => {
  const {
    paths: { registerCardPath }
  } = state

  toastr.options.positionClass = 'toast-footer-small'

  const response = await Http.request(registerCardPath, 'POST', JSON.stringify({ card_details }))
  
  if (!response?.ok) {
    toastr.warning(
      'Something went wrong saving your card details. Please try again.'
    )
    return false
  }
  
  toastr.success(
    'Card details updated successfully.'
  )
  return response.json()
}

export const removeCard = async (state) => {
  const {
    paths: { removeCardPath }
  } = state

  toastr.options.positionClass = 'toast-footer-small'

  const response = await Http.request(removeCardPath, 'DELETE')
  
  if (!response?.ok) {
    toastr.warning(
      'Something went wrong removing your card. Please try again.'
    )
    return false
  }
  
  toastr.success(
    'Card removed successfully.'
  )
  return response.json()
}